import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { Slot } from '@ils/slots/db/slot.js';

export const slotSelector = {
  _class: 1,
  _id: 1,
  tester: 1,
  candidateID: 1,
  startTime: 1,
  roomID: 1,
  endTime: 1,
  inspectors: 1,
  inspectionTime: 1,
  operatorNotes: 1,
  answer: {
    _id: 1,
    _class: 1,
    type: 1,
    text: 1,
    comments: {
      text: 1,
      testerID: 1,
    },
    fileId: 1,
    onlyTraineeFileId: 1,
    slotID: 1,
    reportedError: {
      errorType: 1,
      reportedAt: 1,
      reportedBy: 1,
      description: 1,
    },
  },
  osce: {
    _class: 1,
    _id: 1,
    title: 1,
    durationInMinutes: 1,
    taskType: 1,
    conversationType: 1,
    ratingConfigName: 1,
    titleTrainee: 1,
    enableVideo: 1,
    osceType: 1,
    videoFileID: 1,
    startButtonDuration: 1,
    text: {
      sceneDescriptionTester: 1,
      sceneDescriptionTrainee: 1,
      shortDescription: 1,
      taskDescriptionTrainee: 1,
    },
    instructionCategories: {
      _class: 1,
      description: 1,
      instructions: {
        _class: 1,
        _id: 1,
        question: 1,
        description: 1,
      },
    },
  },
} as const satisfies BaseQLSelectionSet<Slot>;
